import React, { useState } from 'react'
import Navbar from '../../Navbar'
import Sidebar from '../../Sidebar'

import { InfoContainer, InfoWrapper, SectionTitle } from '../FAQ/FAQElements'

const FAQ = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return (
    <>
      <Navbar toggle={toggle} info='Discover' />
      <Sidebar isOpen={isOpen} toggle={toggle} info='Discover' />
      <InfoContainer>
        <InfoWrapper>
          <SectionTitle>FAQ</SectionTitle>
        </InfoWrapper>
      </InfoContainer>
    </>
  )
}

export default FAQ
